import { createRequestTypes } from 'common/websocket-redux';

export const GET_USER_REWARDS_HISTORY = createRequestTypes(
  'rewards-history-page/GET_USER_REWARDS_HISTORY',
);
